import React from 'react';
import Icons from 'components/atoms/Icons';

export type SearchCategory = {
  id: string;
  label: string;
  icon: string;
};

export const SEARCH_CATEGORIES: SearchCategory[] = [
  { id: 'providers', label: 'Providers', icon: 'pld-person' },
  { id: 'locations', label: 'Locations', icon: 'pld-building' },
  { id: 'services', label: 'Services', icon: 'pld-services' },
  { id: 'conditions', label: 'Conditions', icon: 'pld-heart' },
  { id: 'events', label: 'Events', icon: 'icon-calendarNew' },
  { id: 'blog', label: 'Blog', icon: 'pld-blog' },
  { id: 'other', label: 'Other', icon: 'pld-list' },
];

export const getCategoryIconId = (category: SearchCategory, isSelected: boolean): string => {
  const { icon } = category;
  if (!icon) return icon;
  if (!isSelected) return icon;
  return icon.endsWith('-filled') ? icon : `${icon}-filled`;
};
type CategoryPanelProps = {
  active: boolean;
  categories: SearchCategory[];
  selectedCategory: string;
  onSelect: (id: string) => void;
  onClose: () => void;
};

const CategoryPanel = ({
  active,
  categories,
  selectedCategory,
  onSelect,
  onClose,
}: CategoryPanelProps): React.JSX.Element => {
  return (
    <div className={`category-panel-wrapper${active ? ' active' : ''}`}>
      <div className="category-panel">
        <div className="category-panel-title-bar">
          <div className="close-button" onClick={onClose}>
            <Icons id="pld-chevron-right" className="icon-back" aria-hidden="true" />
          </div>
          <h3 className="category-panel-title">Categories</h3>
        </div>
        <div className="category-list">
          {categories.map((category) => {
            const isSelected = selectedCategory === category.id;
            return (
              <button
                key={category.id}
                type="button"
                className={`category-item${isSelected ? ' active' : ''}`}
                onClick={() => onSelect(category.id)}
              >
                {category.icon && (
                  <span className="category-icon">
					<Icons id={getCategoryIconId(category, isSelected)} />                 
					</span>
                )}
                <span className="category-label">{category.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryPanel;